export const environment = {
	production: true,
	gtmPruebas: true,
	envName: 'demo',
	clientId: 'AvI7MZug3dyIZk1JGFNDm+JOX28ruCgtA9I6d71C4Wg=',
	domain: 'midatacredito.com',
	datadog: false,
	// OptinMonster: solo habilitar en ambientes cuyo dominio este registrado en la cuenta
	optinMonster: {
		enabled: false,
		userId: 285762,
		accountId: 303730,
	},
	APIEndpoint_nwuser: 'https://demo.buscacredito.midatacredito.com/nwuser-ws',
	APIEndpoint_ldnfosession: 'https://demo.buscacredito.midatacredito.com/ldnfosession-ws',
	APIEndpoint_bank: 'https://demo.buscacredito.midatacredito.com/bank-ws',
	APIEndpoint_authn: 'https://demo.buscacredito.midatacredito.com/authn-ws',
	APIEndpoint_ngttion: 'https://demo.buscacredito.midatacredito.com/ngttion-ws',
	APIEndpoint_vpce_ws: 'vpce-ws',

	urlLogin: 'https://demo-usuario.midatacredito.com/login?product=bc',
	urlRegister: 'https://demo-usuario.midatacredito.com/registro?product=bc',
	urlProfile: 'https://demo-usuario.midatacredito.com/private/perfil?product=bc',
	urlMIDC: 'https://demo.midatacredito.com/',
	urlIpify: 'https://api.ipify.org?format=json',

	// CloudFront
	enlaces_cloudFront: {
		url: 'https://downelwv7ll3x.cloudfront.net/',
		bcPath: 'Buscacredito/demo',
		terminos_condiciones: 'tyc/terminos_y_condiciones.pdf',
		politica_privacidad: 'tyc/politica_de_tratamiento_de_datos_personales.pdf',
		allLogos: 'assets/demo/allLogos.json'
	},

	Auth: {
		validateSession: '/authn/validateSession',
		logOff: '/authn/signOff'
	},
	InfoSession: {
		ecs: '/sessioninfo/ecs'
	},
	Bank: {
		drPesos:'/intgrtn/drpeso/ClientData?landingCode=BuscaCredito',
		offersListHome: '/ecs/datacash/bank/v2/homeOffers',
		offersListFree: '/ecs/datacash/bank/v1/freeOffers',
		offers: '/ecs/datacash/bank/v1/userOffers',
		offersPreselecta: '/ecs/datacash/bank/v1/userOffersPreselecta',
		offerDetail: '/ecs/datacash/bank/v1/userOfferDetail',
		offerDetailFree: '/ecs/datacash/bank/v1/freeOfferDetail',
		aplicarOferta: '/ecs/datacash/bank/v1/applyOffer',
		applyOfferPreselecta: '/ecs/datacash/bank/v1/applyOfferPreselecta',
		appliedUserOffer: '/ecs/datacash/bank/v1/appliedUserOffer',
		offerHistory: '/ecs/datacash/bank/v1/requesthistory',
		saveOfferEvent: '/ecs/datacash/bank/v1/saveOfferEvent',
		campaignInfo: '/ecs/datacash/bank/v1/campaigninfo',
		customercampaigninfo: '/ecs/datacash/bank/v1/customercampaigninfo',
		applyCampaign: '/ecs/datacash/bank/v1/campaign',
		historyAppliedOffer: '/ecs/datacash/bank/v1/historyAppliedOffer',
		experienceEvaluation: '/ecs/datacash/bank/v1/experienceEvaluation',
		aplicarOfertaDav: '/ecs/datacash/bank/v1/davivienda',
		pagadurias: '/intgrtn/util/pagadurias',
		wasticredit: '/intgrtn/wasticredit',
		softFilters: '/ecs/datacash/bank/v1/soft/filters',
		registerOfferAbandonment: '/ecs/datacash/bank/v1/registerOfferAbandonment',
		categoriesBC: '/api/config/buscacredito/categories/getAll'
	},
	NewUser: {
		updateProfile: '/new-user-ws/api/v1/user/updateProfile',
		addCustomerLog: '/termsConditions/addCustomerLog',
	},
	Negotiation: {
		createValidation: '/autentication/customer/createValidation',
		validation: '/autentication/customer/validation'
	},
	banners: {
		getBanner: '/banners/getBannerNow/BUSCACREDITO'
	},
	cloudFrontBc: {
		categorias: '/categorias.json',
		filter: '/filter.json',
		nitPreselecta: '/nitPreselecta.json'
	},
	country: 'CO',
	slotsBanners: {
		home: '/22857899675/Test_Ad_Unit_BC_Home',
		categorias: '/22857899675/Ad_Unit_Prueba',
		ofertas: '/22857899675/Ad_unit_Prueba_BC2',
		faq: '/22857899675/Test_Ad_Unit_BC_Faq',
		lista_ofertas_1: '/22857899675/Test_Ad_Unit_BC_Ofertas02',
		lista_ofertas_2: '/22857899675/Test_Ad_Unit_BC_Ofertas03',
	},
	conectaBancolombia: {
		customersValidate: "/stg/customers/validate",
		customersAuthenticate: "/stg/customers/authenticate",
		termsRetrieve: "/stg/terms/retrieve",
		termsRegister: "/stg/terms/register",
		decline: "/stg/decline",
		enableOffersPreapproved: "/stg/enable-offers/preapproved",
		simulations: "/stg/simulations",
		accountsRetrieve: "/stg/accounts/retrieve",
		disbursementsConfirm: "/stg/disbursements/confirm",
		customersSignDocument: "/stg/customers/eSignDocument",
		customersSigningCode: "/stg/customers/signingCode",
		disbursements: "/stg/disbursements",
		validateCreditStudy: "/stg/validate-credit-study",
		disbursementsStatus: "/stg/disbursements/status",
	},
	headersBancolombia: {
		'Content-Type': 'application/json',
		'x-apigw-api-id': 'wjwj3gnywg'
	},

	//Endpoint para dataDog
	 APIEndPoints: {
		 urlEndPoints: 'https://dev-o-midc-a13-ui.internal.midc.dev.ecs.us.coaas.net/',
		 loadParameters: '/ldnfosession/load-parameter/byKeyApp'
	 }
};